import React, { useContext } from "react";

import {
  DetalleOpcionGenerica,
  DetalleValoresPorPagar,
  DetalleMovimientosCliente,
  DetalleEstadoCredito,
  DetalleDatosSolicitud,
  DetallePagosTransaccional,
  DetalleDatosSeguros,
  DetalleSiniestros,
  DetalleQuejas,
  DetallePayment,
} from "../containers";

import DetalleTipoPayment from "./DetalleTipoPayment";

import { LISTA_OPCIONES } from "../constants/constants";
import TransaccionalContext from "../context/TransaccionalContext";

const DetalleTransaccionesCliente = ({
  alturaResolucion,
  datosBusqueda,
  cabenceraTransaccional,
}) => {
  const { informacionTransaccional, setInformacionTransaccional } =
    useContext(TransaccionalContext);

  return (
    <main className="movimientoCliente-detalle">
      <section className="movimientoCliente-detalle-informacionContainer">
        {/* OPCION DEFECTO */}
        {informacionTransaccional?.opcionMenu ===
          LISTA_OPCIONES.GENERIC_OPTION && (
          <section className="movimientoCliente-informacion">
            <DetalleOpcionGenerica
              alturaResolucion={alturaResolucion}
              mensaje={"Elije una opción para consultar tus datos."}
            />
          </section>
        )}

        {/* ESTADOS CUENTA */}
        {informacionTransaccional?.opcionMenu ===
          LISTA_OPCIONES.ESTADO_CUENTA && (
          <section className="movimientoCliente-informacion">
            <DetalleValoresPorPagar
              datosBusqueda={datosBusqueda}
              cabenceraTransaccional={cabenceraTransaccional}
              alturaResolucion={alturaResolucion}
            />
          </section>
        )}
        {/* MOV.A LA FECHA */}
        {informacionTransaccional?.opcionMenu === LISTA_OPCIONES.MOV_FECHA && (
          <section className="movimientoCliente-informacion">
            <DetalleMovimientosCliente
              datosBusqueda={datosBusqueda}
              cabenceraTransaccional={cabenceraTransaccional}
              alturaResolucion={alturaResolucion}
            />
          </section>
        )}

        {/* ESTADO CREDITO*/}
        {informacionTransaccional?.opcionMenu ===
          LISTA_OPCIONES.ESTADO_CREDITO && (
          <section className="movimientoCliente-informacion">
            <DetalleEstadoCredito
              datosBusqueda={datosBusqueda}
              cabenceraTransaccional={cabenceraTransaccional}
              alturaResolucion={alturaResolucion}
            />
          </section>
        )}

        {/* ESTADO SOLICITUD*/}
        {informacionTransaccional?.opcionMenu ===
          LISTA_OPCIONES.ESTADO_SOLICITUD && (
          <section className="movimientoCliente-informacion">
            <DetalleDatosSolicitud
              datosBusqueda={datosBusqueda}
              cabenceraTransaccional={cabenceraTransaccional}
              alturaResolucion={alturaResolucion}
            />
          </section>
        )}
        {/* PAGOS */}
        {informacionTransaccional?.opcionMenu === LISTA_OPCIONES.PAGOS && (
          <section className="movimientoCliente-informacion">
            <DetallePagosTransaccional
              datosBusqueda={datosBusqueda}
              cabenceraTransaccional={cabenceraTransaccional}
              alturaResolucion={alturaResolucion}
            />
          </section>
        )}
        {/* DATOS SEGURO */}
        {informacionTransaccional?.opcionMenu ===
          LISTA_OPCIONES.DATOS_SEGURO && (
          <section className="movimientoCliente-informacion">
            <DetalleDatosSeguros
              datosBusqueda={datosBusqueda}
              cabenceraTransaccional={cabenceraTransaccional}
              alturaResolucion={alturaResolucion}
            />
          </section>
        )}
        {/* SINIESTROS */}
        {informacionTransaccional?.opcionMenu === LISTA_OPCIONES.SINIESTROS && (
          <section className="movimientoCliente-informacion">
            <DetalleSiniestros
              datosBusqueda={datosBusqueda}
              cabenceraTransaccional={cabenceraTransaccional}
              alturaResolucion={alturaResolucion}
            />
          </section>
        )}
        {/* QUEJAS */}
        {informacionTransaccional?.opcionMenu === LISTA_OPCIONES.QUEJAS && (
          <section className="movimientoCliente-informacion">
            <DetalleQuejas
              datosBusqueda={datosBusqueda}
              cabenceraTransaccional={cabenceraTransaccional}
              alturaResolucion={alturaResolucion}
            />
          </section>
        )}
        {/* PAYMENT */}
        {informacionTransaccional?.opcionMenu === LISTA_OPCIONES.PAYMENT &&
          datosBusqueda?.idGrupo === 1 && (
            <section className="movimientoCliente-informacion">
              <DetallePayment
                datosBusqueda={datosBusqueda}
                cabenceraTransaccional={cabenceraTransaccional}
                alturaResolucion={alturaResolucion}
              />
              {/* <DetalleTipoPayment
              alturaResolucion={alturaResolucion}
              datosBusqueda={datosBusqueda}
              cabenceraTransaccional={cabenceraTransaccional}
            /> */}
            </section>
          )}
      </section>
    </main>
  );
};

export default DetalleTransaccionesCliente;
